module.exports = __webpack_public_path__ + "img/Racing-Max.25aa9bf3.svg";